export const TRAE_RECETAS_PETICION = "TRAE_RECETAS_PETICION";
export const AGREGA_ITEM_RECETA = "ADD_ITEM_RECETA";
export const BORRAR_RECETA = "BORRAR_RECETA";
export const SET_RECETAS = "SET_RECETAS";
